import {
  Companion_instance2812viivi1viv as Companion_instance,
  AlwaysSharedCopyTracker_getInstance3ilko79l185t as AlwaysSharedCopyTracker_getInstance,
} from './Segment.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SegmentPoolClass;
function SegmentPool() {
  if (SegmentPoolClass === VOID) {
    class $ {
      constructor() {
        this.k4g_1 = 0;
        this.l4g_1 = 0;
      }
      o3t() {
        return Companion_instance.n4h();
      }
      a4h(segment) {
      }
      r4h() {
        return AlwaysSharedCopyTracker_getInstance();
      }
    }
    initMetadataForObject($, 'SegmentPool');
    SegmentPoolClass = $;
  }
  return SegmentPoolClass;
}
var SegmentPool_instance;
function SegmentPool_getInstance() {
  return SegmentPool_instance;
}
//region block: init
SegmentPool_instance = new (SegmentPool())();
//endregion
//region block: exports
export {
  SegmentPool_instance as SegmentPool_instance37ddoilc7l0w6,
};
//endregion

//# sourceMappingURL=SegmentPool.mjs.map
